import { twJoin, twMerge } from 'tailwind-merge';

export const cnJoin = twJoin;
export const cnMerge = twMerge;
